<template>
	<div>
		<router-view v-if="$route.path.includes('InvitDatails')"></router-view>
		<div v-else>
			<div class="navlist">
				<ul>
					<li v-for="(i,Index) in navlist"
					  :key='index'
					  :class="{'classType':Index==navindex}" 
					   @click="tobnav(Index)"
					>
					{{i.name}}
					<div v-if="Index==navindex"></div>
					</li>
				</ul>
				<div class="navso">
					<div class="soinput">
					  <i class="el-icon-search"></i>
					  <input type="text" placeholder="请输入您要搜索的内容" v-model="keyword"> 
					</div>
					<button @click="gxdata">搜索</button>
				</div>
			</div>
			<demandInvit :list="list"></demandInvit>
			<div class="fenye">
			   <el-pagination
				 background
				 @current-change="handleCurrentChange"
				 :current-page.sync="currentPage1"
				 :page-size="9"
				 layout="total, prev, pager, next ,jumper"
				 :total="total">
			   </el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import {DemandInviteIndex} from "@/api/api.js"
	import demandInvit from '@/common/demandInvit.vue';
	export default {
	  name: 'HelloWorld',
	  components:{
		  demandInvit
	  },
	  data() {
	    return {
			navindex:0,
			navnumber:1,
			navlist:[
			   {name:"全部",status:""},
			   {name:"已邀标",status:"0"},
			   {name:"已参与",status:"1"},
			   {name:"已拒绝",status:"-1"}
			],
			keyword:'',
			page:1,
			list:[],
			status:"",
			total:"",
			pagecount:"",
			currentPage1:"",
	    }
	  },
	  created() {
	  	this.getlist()
	  },
	  methods: {
		  gxdata(){
			  this.page=1
			  this.getlist()
		  },
		  handleCurrentChange(e){
		  	this.page=e
		  	this.getlist()
		  },
		  tobnav(index){
		  	this.navindex=index
		  	this.status=this.navlist[index].status
		  	this.page=1
		  	this.getlist()
		  },
		  getlist(){
		  	DemandInviteIndex({
		  		page:this.page,
		  		limit:"9",
		  		keyword:this.keyword,
		  		status:this.status
		  	}).then(res=>{
				this.total=res.data.data.total
				this.pagecount=res.data.data.pass_count
				this.currentPage1=res.data.data.current_page
		  		this.list=res.data.data.data
		  	})
		  },
	
	  },
	}
</script>
<style scoped>
	.navlist{
		width:1200px;
		margin:0 auto;
		height: 48px;
		border-radius: 12px;
		margin-top:24px;
		margin-bottom:24px;
		padding:8px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.navlist ul{
		display:flex;
		align-items:center;
	}
	.navlist li{
		margin-right:16px;
		font-weight: 400;
		font-size: 14px;
		color: #666666;
		cursor:pointer;
		position:relative;
		padding-bottom:10px;
	}
	.navlist li>div{
		position:absolute;
		width:20px;
		height:3px;
		border-radius:3px;
		background-color: #1E3A8A;
		margin-left: -10px;
		left: 50%;
		bottom: 0;
	}
	.navso{
		width: 360px;
		height: 40px;
		background: #FFFFFF;
		border-radius: 12px;
		border: 1px solid #1E3A8A;
		padding: 7px 8px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.soinput{
		display:flex;
		align-items:center;
	}
	.navso input{
		width:270px;
		border:none;
		outline:none;
		margin-left:5px;
	}
	.navso button{
		width:60px;
		height:32px;
		background: #1E3A8A;
		border-radius: 6px;
		color:#fff;
		border:none;
		outline: none;
		font-weight: 400;
		font-size: 12px;
		cursor: pointer;
	}
	.fenye{
		width:100%;
		display:flex;
		justify-content:center;
		align-items: center;
		padding-bottom:60px;
	}
	.classType{
		color: #1E3A8A !important;
	}
</style>